import FormCreatePlan from '../../components/Forms/FormCreatePlan'

export default function PlanCreatePage() {
    return (<>
        <FormCreatePlan />
    </>)
}